module.exports = __webpack_public_path__ + "static/media/dobby.f3c992e8.jpg";